import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { UaService } from '@ecm/consumer';
import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, LinkService, RouterService } from '@ecm/router';

import { ContractV7Offer } from '../../../../business/api/dashboardV7/contract/contractV7Offer';
import { UrlService } from '../../../../services/url.service';
import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'gauge-sub-item',
    templateUrl: 'gauge-sub-item.html',
    styleUrls: ['../sub-item.css', 'gauge-sub-item.css'],
    standalone: true,
    imports: [EcmMaterialModule, NgTemplateOutlet, NgClass, AsyncPipe, EcmRouterModule],
})
export class GaugeSubItemComponent extends SubItemComponent implements OnInit {
    @Input()
    public offer!: ContractV7Offer;

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        protected linkService: LinkService,
        protected urlService: UrlService,
    ) {
        super(uaService, routerService, linkService, urlService);
    }
}
